const Content = ({ children }) => {
  return <div className="container-fluid">{children}</div>;
};

export { Content };
